export default __webpack_public_path__ + "static/media/detail_hover.70788064.svg";